import {
  GET_ALL_LOGS,
  CLEAR_ALL_LOGS,
  GET_LOGS_ACTION_TYPES
} from '../constants/constants';

const initialState = { logs: [], totalElements: 0, actions: [] };

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_LOGS:
      return {
        ...state,
        logs: [...action.logs.content],
        totalElements: action.logs.totalElements
      };
    case GET_LOGS_ACTION_TYPES:
      return {
        ...state,
        actions: [ ...action.actions ]
      };
    case CLEAR_ALL_LOGS:
      return {
        ...state,
        logs: [],
        totalElements: 0
      };
    default: return state;
  }
}

export const getLogs = state => state.logsReducer.logs;
export const getActionType = state => state.logsReducer.actions;
export const getCountLogs = state => state.logsReducer.totalElements;